import * as ko from 'knockout';
import LoginFormViewModel from './LoginFormViewModel';
import FormViewModel from './FormViewModel';
import { clearSession, readAccessToken } from '../utils';
class MainViewModel {
    constructor() {
        this.isUserAuthenticated = ko.observable(false);
        this.profileName = ko.observable('');
        this.externalSystem = ko.observable('');
        this.formViewModel = new FormViewModel(this);
        this.showLoginForm = ko.observable(true);
        this.showFormStep2 = ko.observable(false);
        this.showFormStep3 = ko.observable(false); // Assuming you have a Form Step 3
        // ... other form steps visibility observables ...
        this.notification = ko.observable(null); // Add notification observable
        this.helpUrl = ko.computed(() => {
            const system = this.externalSystem();
            if (system === 'casavi') {
                return 'https://incon.atlassian.net/wiki/external/NzU4MmM5MTkwNTdmNDg5NWJjOGI5ZjcwZTIxNWUxYjk';
            }
            else if (system === 'facilioo') {
                return 'https://incon.atlassian.net/wiki/external/YmE1NTM5MWQxMzZiNDFjMTk1Yjk4YTQ4NWE4YTk3YWU';
            }
            return '#'; // Default or empty URL
        });
        this.logout = () => {
            // Clear local storage
            localStorage.removeItem('accessToken');
            localStorage.removeItem('licenseKey');
            localStorage.removeItem('profileId');
            localStorage.removeItem('externalSystem');
            localStorage.removeItem('profileName');
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_phone');
            // Reset authentication state
            this.isUserAuthenticated(false);
            // Go back to login form
            this.goToStep1();
        };
        this.goToStep1 = () => {
            this.showLoginForm(true);
            this.showFormStep2(false);
            this.showFormStep3(false);
            // ... hide other form steps ...
        };
        this.goToStep2 = () => {
            this.showLoginForm(false);
            this.showFormStep2(true);
            this.showFormStep3(false);
            // ... hide other form steps ...
        };
        this.goToStep3 = () => {
            this.showLoginForm(false);
            this.showFormStep2(false);
            this.showFormStep3(true);
            // ... hide other form steps ...
            // Call fetchIncidentFields when transitioning to Step 3
            this.formViewModel.fetchIncidentFields();
        };
        // When creating LoginFormViewModel, pass a callback that sets isUserAuthenticated
        this.loginFormViewModel = new LoginFormViewModel(() => {
            this.isUserAuthenticated(true);
            this.profileName(localStorage.getItem('profileName') || '');
            this.externalSystem(localStorage.getItem('externalSystem') || '');
            this.notification(''); // Clear any previous notifications
            this.goToStep2();
        }, this);
        // Auto-Login, wenn ein lesbarer Token vorliegt (JSON-kodiert oder roh, siehe readAccessToken)
        const token = readAccessToken();
        if (token) {
            this.isUserAuthenticated(true);
            this.profileName(localStorage.getItem('profileName') || '');
            this.externalSystem(localStorage.getItem('externalSystem') || '');
            // Die Sitzung kann in der Subscription bereits verworfen worden sein (z. B. fehlende Daten) → dann bleibt das Login
            if (this.isUserAuthenticated()) {
                this.goToStep2();
            }
        }
        else {
            // Reste einer defekten oder alten Sitzung entfernen, damit kein Aufruf mit kaputtem Token startet
            clearSession();
        }
    }
}
export default MainViewModel;
